// extracted by mini-css-extract-plugin
export default {"titleInput":"index_titleInput__e+7Av"};